import { useState, useEffect } from "react";
import useAuth from "../../../hooks/useAuth";
import { MailIcon } from "lucide-react";

export default function AuthEmailVerifyView() {
  const { resendVerificationEmail } = useAuth();
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    resendVerificationEmail();
  }, []);

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const handleResendEmail = () => {
    if (cooldown === 0) {
      resendVerificationEmail();
      setCooldown(30);
    }
  };

  return (<div className="p-4 py-8 flex flex-col items-center justify-center text-center">
    <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6 animate-bounce">
      <span className="material-icons-outlined text-primary text-3xl">
        <MailIcon />
      </span>
    </div>
    <h1 className="text-2xl font-bold text-slate-900 mb-3">Check your email</h1>
    <p className="text-slate-600 mb-8 leading-relaxed">
      We&apos;ve sent a verification link to your email address. Please click the link in the email to continue.
    </p>
    <div className="w-full space-y-3">
      <button onClick={handleResendEmail}
      disabled={cooldown > 0}
      className="w-full bg-slate-50 hover:bg-slate-100 text-slate-700 font-semibold py-4 rounded-xl transition-all active:scale-[0.98] border border-slate-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-slate-50">
        {cooldown > 0 ? `Resend Email (${cooldown}s)` : 'Resend Email'}
      </button>
    </div>
  </div>);
}
